export const categories = [
  {
    slug: 'dianshi',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门电视剧免费在线观看，每日更新最新剧集',
    count: 1256,
  },
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-movie-line',
    description: '高清电影资源库，动作片、爱情片、科幻片应有尽有',
    count: 2341,
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-live-line',
    description: '热门综艺节目合集，搞笑、真人秀、音乐竞技',
    count: 892,
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-ghost-line',
    description: '日本动漫、国产动漫高清在线，热血、治愈、搞笑',
    count: 1567,
  },
  {
    slug: 'duanpian',
    name: '短片',
    icon: 'ri-vidicon-line',
    description: '精彩短视频合集，创意短片、微电影、纪录片',
    count: 678,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '精品纪录片资源，自然、人文、历史、科技',
    count: 445,
  },
  {
    slug: 'juji',
    name: '剧集推荐',
    icon: 'ri-fire-line',
    description: '编辑精选高分剧集，追剧达人不可错过',
    count: 523,
  },
  {
    slug: 'yugao',
    name: '预告片',
    icon: 'ri-slideshow-line',
    description: '最新影视预告，抢先了解即将上映的精彩大片',
    count: 312,
  },
];

export const heroVideos = [
  {
    slug: 'qingyu-nian-2',
    title: '庆余年 第二季',
    category: '电视剧',
    categorySlug: 'dianshi',
    rating: 9.4,
    description: '范闲归来，京都风云再起！看范闲如何在权力漩涡中运筹帷幄，揭开重重谜团，重塑庆国格局。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%20with%20ancient%20palace%20interior%2C%20warm%20golden%20lighting%2C%20traditional%20Chinese%20architecture%20elements%2C%20dramatic%20atmospheric%20composition%2C%20rich%20red%20and%20gold%20color%20palette%2C%20cinematic%20photography%20with%20soft%20shadows%2C%20majestic%20and%20grand%20visual%20style&width=1600&height=800&seq=hero-video-01&orientation=landscape',
    tags: ['热播', '古装', '权谋'],
  },
  {
    slug: 'liulangdiqiu-3',
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'dianying',
    rating: 8.9,
    description: '人类命运何去何从？太阳系的终结倒计时开始，人类文明将面临前所未有的终极挑战。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20space%20scene%20with%20Earth%20floating%20in%20dark%20cosmic%20background%2C%20dramatic%20lighting%20from%20nearby%20star%2C%20epic%20cinematic%20composition%2C%20deep%20blue%20and%20orange%20color%20contrast%2C%20atmospheric%20nebula%20effects%2C%20grand%20scale%20visual%20with%20tiny%20spaceships%20nearby&width=1600&height=800&seq=hero-video-02&orientation=landscape',
    tags: ['热播', '科幻', '大片'],
  },
  {
    slug: 'chengfeng-polang-5',
    title: '乘风破浪的姐姐 第五季',
    category: '综艺',
    categorySlug: 'zongyi',
    rating: 8.7,
    description: '姐姐们再度集结！舞台竞演升级，谁能突破自我，在聚光灯下绽放最耀眼的光芒？',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20stage%20performance%20scene%20with%20dramatic%20spotlight%20effects%2C%20elegant%20female%20silhouette%20on%20stage%2C%20purple%20and%20gold%20lighting%20atmosphere%2C%20glamorous%20entertainment%20show%20visual%2C%20dynamic%20stage%20design%20with%20flowing%20fabric%20and%20sparkle%20effects&width=1600&height=800&seq=hero-video-03&orientation=landscape',
    tags: ['热播', '竞技', '音乐'],
  },
];

export const featuredVideos = [
  {
    slug: 'fanhua',
    title: '繁花',
    category: '电视剧',
    categorySlug: 'dianshi',
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20lights%20and%20vintage%20cars%2C%20warm%20atmospheric%20evening%20lighting%2C%20nostalgic%20Chinese%20urban%20scene%2C%20elegant%20retro%20aesthetic%2C%20golden%20hour%20ambiance%20on%20city%20street&width=800&height=500&seq=featured-01&orientation=landscape',
    duration: '30集全',
    updateTime: '2026-08-06',
  },
  {
    slug: 'manjianghong',
    title: '满江红',
    category: '电影',
    categorySlug: 'dianying',
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20at%20night%20with%20red%20lanterns%20and%20narrow%20corridors%2C%20mysterious%20atmospheric%20lighting%2C%20traditional%20Chinese%20architecture%20with%20shadows%2C%20historical%20drama%20setting%20with%20suspenseful%20mood&width=800&height=500&seq=featured-02&orientation=landscape',
    duration: '159分钟',
    updateTime: '2026-08-05',
  },
  {
    slug: 'quan-zhi-gao-shou-3',
    title: '全职高手 第三季',
    category: '动漫',
    categorySlug: 'dongman',
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20digital%20esports%20arena%20with%20glowing%20holographic%20effects%2C%20futuristic%20gaming%20environment%2C%20dynamic%20action%20composition%2C%20vibrant%20neon%20cyan%20and%20magenta%20color%20scheme%2C%20energetic%20competitive%20atmosphere&width=800&height=500&seq=featured-03&orientation=landscape',
    duration: '12集全',
    updateTime: '2026-08-04',
  },
  {
    slug: 'dixia-cheng-yu-yongshi',
    title: '地下城与勇士：起源',
    category: '动漫',
    categorySlug: 'dongman',
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20scene%20with%20warrior%20characters%20in%20dungeon%20environment%2C%20dramatic%20lighting%20from%20magical%20sources%2C%20epic%20action%20pose%2C%20dark%20stone%20walls%20with%20glowing%20runes%2C%20cinematic%20game%20adaptation%20visual%20style&width=800&height=500&seq=featured-04&orientation=landscape',
    duration: '24集全',
    updateTime: '2026-08-03',
  },
  {
    slug: 'minglong-shaonian',
    title: '鸣龙少年',
    category: '电视剧',
    categorySlug: 'dianshi',
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20high%20school%20classroom%20with%20sunlight%20streaming%20through%20windows%2C%20warm%20and%20inspiring%20atmosphere%2C%20youth%20campus%20drama%20setting%2C%20books%20on%20desks%2C%20hopeful%20and%20bright%20visual%20tone&width=800&height=500&seq=featured-05&orientation=landscape',
    duration: '30集全',
    updateTime: '2026-08-02',
  },
  {
    slug: 'kunlun-shengong',
    title: '昆仑神宫',
    category: '电影',
    categorySlug: 'dianying',
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20snowy%20mountain%20landscape%20with%20ancient%20ruins%2C%20adventure%20exploration%20atmosphere%2C%20cold%20blue%20and%20white%20color%20tone%2C%20dramatic%20clouds%20over%20peaks%2C%20epic%20wilderness%20cinematography%20with%20sense%20of%20mystery&width=800&height=500&seq=featured-06&orientation=landscape',
    duration: '112分钟',
    updateTime: '2026-08-01',
  },
  {
    slug: 'zhe-jiu-shi-jie-wu',
    title: '这就是街舞 第六季',
    category: '综艺',
    categorySlug: 'zongyi',
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20street%20dance%20competition%20stage%20with%20colorful%20neon%20lighting%2C%20energetic%20urban%20atmosphere%2C%20industrial%20warehouse%20style%20venue%2C%20graffiti%20art%20background%2C%20vibrant%20and%20cool%20entertainment%20show%20visual&width=800&height=500&seq=featured-07&orientation=landscape',
    duration: '12期',
    updateTime: '2026-07-31',
  },
  {
    slug: 'santi-donghua',
    title: '三体 动画版',
    category: '动漫',
    categorySlug: 'dongman',
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20laboratory%20with%20holographic%20displays%20and%20complex%20equations%2C%20dark%20atmospheric%20lighting%20with%20blue%20accents%2C%20advanced%20technology%20environment%2C%20mysterious%20and%20intellectual%20visual%20style%2C%20cosmic%20theme%20elements&width=800&height=500&seq=featured-08&orientation=landscape',
    duration: '15集全',
    updateTime: '2026-07-30',
  },
];

export const latestUpdates = [
  {
    slug: 'dafeng-dagengren',
    title: '大奉打更人',
    category: '电视剧',
    categorySlug: 'dianshi',
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20detective%20investigation%20scene%20with%20mysterious%20night%20atmosphere%2C%20traditional%20courtyard%20setting%2C%20lantern%20light%20creating%20dramatic%20shadows%2C%20historical%20mystery%20drama%20visual%20style&width=400&height=240&seq=latest-01&orientation=landscape',
    updateLabel: '更新至第36集',
    updateTime: '2026-08-07',
  },
  {
    slug: 'xiao-shid-de-dacheng',
    title: '小食店的大成',
    category: '纪录片',
    categorySlug: 'jilupian',
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20Chinese%20street%20food%20stall%20with%20steaming%20hot%20dishes%2C%20warm%20evening%20lighting%2C%20traditional%20cooking%20scene%2C%20nostalgic%20and%20comforting%20atmosphere%2C%20authentic%20local%20food%20culture%20documentary%20style&width=400&height=240&seq=latest-02&orientation=landscape',
    updateLabel: '更新至第8集',
    updateTime: '2026-08-07',
  },
  {
    slug: 'nishui-han',
    title: '逆水寒',
    category: '电视剧',
    categorySlug: 'dianshi',
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20scene%20with%20flowing%20robes%20in%20ancient%20landscape%2C%20misty%20mountain%20background%2C%20dramatic%20action%20pose%2C%20traditional%20wuxia%20aesthetic%20with%20warm%20golden%20sunlight&width=400&height=240&seq=latest-03&orientation=landscape',
    updateLabel: '更新至第28集',
    updateTime: '2026-08-07',
  },
  {
    slug: 'xi-you-ji-zhi-da-nao-tiangong',
    title: '西游记之大闹天宫',
    category: '动漫',
    categorySlug: 'dongman',
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20animation%20scene%20with%20monkey%20king%20in%20celestial%20palace%2C%20vibrant%20colors%20and%20clouds%2C%20traditional%20Chinese%20art%20style%2C%20epic%20heavenly%20setting%20with%20golden%20light%20rays&width=400&height=240&seq=latest-04&orientation=landscape',
    updateLabel: '更新至第12集',
    updateTime: '2026-08-06',
  },
  {
    slug: 'yuzhou-bianhua',
    title: '宇宙变化',
    category: '纪录片',
    categorySlug: 'jilupian',
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Deep%20space%20nebula%20and%20galaxy%20scene%20with%20vibrant%20purple%20and%20blue%20cosmic%20colors%2C%20stars%20and%20celestial%20bodies%2C%20awe-inspiring%20astronomical%20documentary%20visual%2C%20scientific%20and%20majestic%20atmosphere&width=400&height=240&seq=latest-05&orientation=landscape',
    updateLabel: '更新至第5集',
    updateTime: '2026-08-06',
  },
  {
    slug: 'kaixinshike',
    title: '开心时刻 第七季',
    category: '综艺',
    categorySlug: 'zongyi',
    rating: 8.1,
    image: 'https://readdy.ai/api/search-image?query=Bright%20and%20colorful%20comedy%20show%20studio%20with%20cheerful%20atmosphere%2C%20warm%20stage%20lighting%2C%20entertainment%20variety%20show%20setting%2C%20fun%20and%20lively%20visual%20with%20audience%20seats&width=400&height=240&seq=latest-06&orientation=landscape',
    updateLabel: '更新至第10期',
    updateTime: '2026-08-05',
  },
];

export const statsData = [
  { label: '视频资源', value: '12,580+', icon: 'ri-movie-line' },
  { label: '每日更新', value: '200+', icon: 'ri-refresh-line' },
  { label: '高清画质', value: '4K', icon: 'ri-4k-line' },
  { label: '完全免费', value: '永久', icon: 'ri-vip-crown-line' },
];